import React from 'react'
import { connect } from 'react-redux'
import { RootState } from '../../types/rootstate'

interface StateProps {
  liveMessage: string
}

interface DispatchProps {
}

interface OwnProps {}

type AnnouncerProps = StateProps & DispatchProps & OwnProps

function mapStateToProps (state: RootState): StateProps {
  return {
    liveMessage: state.a11y.liveMessage
  }
}

function mapDispatchToProps (dispatch): DispatchProps {
  return {
  }
}

export class AnnouncerComponent extends React.Component<AnnouncerProps, undefined> {
  render () {
    return (
      <>
        <div id='live-message' aria-live='polite'>
          {this.props.liveMessage}
        </div>
        {this.props.children}
      </>
    )
  }
}

const Announcer = connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(AnnouncerComponent)

export {
  Announcer
}
